<template>
  <v-autocomplete
    v-model="item"
    :label="label"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    :clearable="!disabled"
    hide-no-data
    :hide-details="hideDetails"
    item-text="nazev"
    item-id="id"
    :filter="filter"
    return-object
    :outline="outline"
    ref="select"
    :cache-items="false"
    :disabled="disabled"
    class="mx-2"
  >
    <template
      slot="selection"
      slot-scope="{ item, selected }"
    >
      <span v-text="item.nazev"></span>
    </template>
    <template
      slot="item"
      slot-scope="{ item, tile }"
    >
      <v-list-tile-content>
        <v-list-tile-title>{{ item.nazev }}</v-list-tile-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  data: function () {
    return {
      loading: false,
      items: [],
      search: "",
      counter: 0,
      timeout: null,
      item: null,
      muteWatchOnce: false
    }
  },
  props: {
    loadOnMounted: Boolean,
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: Number,
    all: Boolean,
    label: String,
    disabled: Boolean,
    except: Array,
    material: Number,
    typ_produktu: String,
    vaha: Number,
    autoload: Boolean,
    clearOnSelect: Boolean,
    noLimit: Boolean
  },
  watch: {
    search (val) {
      val && val !== this.item && this.queryClients(val)
    },
    item (v) {
      if (this.muteWatchOnce) {
        this.muteWatchOnce = false;
        return;
      }
      if (v != null) {
        this.$emit("changed", v);
        this.$emit("input", v.id);
      }
      else {
        this.$emit("changed", null);
        this.$emit("input", null);
      }
      if (this.$props.clearOnSelect) {
        this.muteWatchOnce = true;
        this.clearItem();
      }
    }
  },
  mounted: function() {
    if (this.value != null || this.autoload)
      this.loadBasic();
    if (this.loadOnMounted)
      this.load("");
  },
  methods: {
    filter: function(e) {
      return true;
    },
    queryClients: function(v) {
      this.counter++;
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.load(v);
      }.bind(this), 300)
    },
    load (v) {
      this.loading = true;
      this.counter++;
      window.api.post("produkty/search", {
        s: v,
        echo: this.counter,
        typ_produktu: typeof this.$props.typ_produktu != "undefined" && this.$props.typ_produktu != null && this.$props.typ_produktu.length > 0 ? this.$props.typ_produktu : null,
        material: typeof this.$props.material != "undefined" && this.$props.material != null ? this.$props.material : null,
        vaha_g: typeof this.$props.vaha != "undefined" && this.$props.vaha != null ? this.$props.vaha : null,
        except: typeof this.$props.except != "undefined" && this.$props.except != null ? this.$props.except : [],
        aktivni: true,
        pagination: this.noLimit ? {
          rowsPerPage: 50
        } : null
      }).then(function($r) {
        if ($r.echo != this.counter) return;
        this.items = $r.data;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    loadBasic: function() {
      window.api.get("produkty/"+this.value+"/basic").then((item) => {
        this.items.push(item);
        this.item = this.items[0];
      }).catch((err) => {
        console.log(err);
      });
    },
    clearItem () {
      this.item = null;
      this.search = "";
      this.items = [];
      if (this.loadOnMounted)
        this.load("");
    },
    clearSelectedItem () {
      this.item = null;
      this.search = "";
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
